import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import { acquireToken, login } from "@/plugins/azureAuth";
import router from '@/router';

/**
 * Service to make HTTP requests to the server using Axios
 */
const ApiService = {
  
  /** List of server endpoints that require authentication */
  AUTH_ENDPOINTS: ['/nb/', '/coc/', '/fleet-upload/processing/', '/policy-details/', '/prospect-form/', '/quote-slip-processing/', '/billing/', '/workbench/'],
  
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? `http://localhost:3000/services` : `${window.location.origin}/services`;
    
    // Add request interceptor to automatically include security token
    axios.interceptors.request.use(
      async (config) => {
        
        // If a session token is available (Puppeteer internal access), use it directly
        if (window.__sessionToken) {
          config.headers.Authorization = `Bearer ${window.__sessionToken}`;
          return config;
        }
        
        // Check if current UI route requires authentication
        const currentUiRoute = router.currentRoute.name;
        const requiresAuthUi = router.getRoutes().some(route => route.name === currentUiRoute && route.meta.requiresAuth);
        
        // Check if the server endpoint requires authentication
        const endpointUrl = config.url;
        const requiresAuthSever = this.AUTH_ENDPOINTS.some(endpoint => endpointUrl.startsWith(endpoint));
        
        const requiresAuth = requiresAuthUi || requiresAuthSever;
        if (requiresAuth) {
          const token = await acquireToken();
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          }
          else {
            await login();
            return;
          }
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param config
   * @returns {*}
   */
  get(resource, config) {
    return Vue.axios.get(`${resource}`, config);
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param data
   * @param config
   * @returns {*}
   */
  post(resource, data, config) {
    return Vue.axios.post(`${resource}`, data, config);
  }
};

export default ApiService;
